var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayInExt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16 4.001h7.144l.492.013c.918.036 1.454.146 1.896.322l.215.094a3.637 3.637 0 0 1 1.823 1.823l.094.215c.176.442.286.978.322 1.896l.012.491.002.273V28H9.128l-.272-.002-.492-.012c-.918-.037-1.454-.146-1.896-.322l-.215-.094a3.637 3.637 0 0 1-1.823-1.823l-.094-.215c-.176-.442-.286-.978-.322-1.896l-.012-.492L4 16h2v7.11l.009.417.016.346c.03.472.093.744.197.983l.076.155c.162.304.388.53.692.692l.155.076c.239.104.511.166.983.197l.346.016.416.008H16v-7a3 3 0 0 1 3-3l6.999-.001V8.89l-.008-.416-.016-.346c-.03-.472-.093-.744-.197-.983l-.076-.156a1.63 1.63 0 0 0-.692-.691l-.155-.076c-.239-.104-.511-.166-.983-.197l-.346-.016L23.11 6H16V4.001zM20 19v6l5-3-5-3zM4.381 4.381a1.302 1.302 0 0 1 1.841 0l4.295 4.295V5.799a1.242 1.242 0 0 1 2.484-.001v6.954a.249.249 0 0 1-.249.248H5.8a1.242 1.242 0 1 1 0-2.483h2.877L4.38 6.222a1.301 1.301 0 0 1 0-1.84z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.87,
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayInExt);
export default __webpack_public_path__ + "static/media/icon-play-in-ext.6e54f0dccb4a90402618df93e36fd8e6.svg";
export { ForwardRef as ReactComponent };